const articlesStore = {
  namespaced: true,
  state: () => ({
    me: 'articles',
    sandBox: null,
    sopifyStoreFrontAccessToken: 'c3ddcc0e43bb4e669cef10045abba8d4',
    // sopifyStoreFrontClient: shopify.clients.Storefront({ // ShopifyBuy.buildClient
    //   domain: 'ackuretta-shop.myshopify.com',
    //   storefrontAccessToken: 'c3ddcc0e43bb4e669cef10045abba8d4',
    // })
  }),
  getters: {
    me: state => state.me,   
    articlesArray: state => blogArticles
  },
  mutations: {
    setSandBox(state, data){
      state.sandBox = data
    },
    
  },
  actions: {
    sayHi(){
      appLog.log('HIIIIII articles')
    },

    getLastArticles({getters}){
      return window.blogArticles
    //   let blogHandle = 'news' //press-releases
    //   let limit = 3
    //   const query = {
    //     query: `{
    //       blogByHandle(handle: "${blogHandle}") {
    //         articles(first: ${limit}, sortKey: CREATED_AT, reverse: true) {
    //           edges {
    //             node {
    //               title
    //               url
    //             }
    //           }
    //         }
    //       }
    //     }`
    //   }


    // return axios.post('https://ackuretta-shop.myshopify.com', query, {
    //   headers: {
    //     'content-type': 'application/json',
    //     'X-Shopify-Storefront-Access-Token': getters.sopifyStoreFrontAccessToken,
    //     "Access-Control-Allow-Origin": "https://ackuretta.com",
    //     "Access-Control-Allow-Methods": "GET, OPTIONS",
    //     "Access-Control-Headers": "*",
    //     "Access-Control-Allow-Credentials": "true"
    //   }
    // })
    // .then((response)=>{
    //   return response.data.blogByHandle.articles.edges
    // })
    // .catch((error) => {
    //   appLog.error('Error fetching articles:', error)
    // })

    //   // try {
    //   //   return getters.sopifyStoreFrontClient.graphQLClient.send(query)
    //   //   .then((response)=>{
    //   //     return response.data.blogByHandle.articles.edges
    //   //   })
    //   //   // const articles = response.data.blogByHandle.articles.edges
    //   //   // return articles
    //   // } catch (error) {
    //   //   appLog.error('Error fetching articles:', error)
    //   //   return []
    //   // }
    }
    
  }

}

vStore.registerModule('articles', articlesStore)